import { createAsyncThunk } from '@reduxjs/toolkit';
import { _commonUrls } from '@custom/Utils/constants/apiUrls';

const uploadReportImgs = createAsyncThunk('uploadReportImgs', async (formData: FormData) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token') || sessionStorage.getItem('shareAuthToken') || localStorage.getItem('shareAuthToken')
    const response = await fetch(_commonUrls.uploadMultipleImgs, {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP status ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    throw new Error(`Error uploading file: ${error.message}`);
  }
});

export default uploadReportImgs;
